<template>
  <router-view />
</template>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', Roboto, Arial, sans-serif;
  background: #f5f6fa;
  color: #1e2233;
}
</style>
